/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';

import { DropdownSubmenu } from './DropdownSubmenu';
import { SheetSubmenu } from './SheetSubmenu';
import { useMenuContext } from './useMenuContext';

export type SubmenuProps = {
  /**
   * Set of menu groups or menu items that submenumenu will hold.Even though you could pass other type of children,
   * is strongly recommended to use MenuItem, menu groups or components that return this type of components
   * since passing other type of components children produces not desirable behaviors.
   */
  children?: ComponentChildren;

  /**
   *  Determines submenu text.
   */
  label: string;

  /**
   *  Submenu item startIcon
   */
  startIcon?: ComponentChildren;
  /**
   *  Item key
   */
  itemKey?: string;
};

/*Submenu behaves differently depending the device */
export const Submenu = (props: SubmenuProps) => {
  const { isMobile } = useMenuContext();
  return (
    <>
      {isMobile ? (
        <SheetSubmenu {...props}></SheetSubmenu>
      ) : (
        <DropdownSubmenu {...props}></DropdownSubmenu>
      )}
    </>
  );
};
